// 2-minute walkthroughs — one per core feature. Linked from the day-3 trial check-in email and the dashboard.
export const WALKTHROUGHS = {
  dispatch: {
    label: "Dispatch board", minutes: 2, path: "/app/dispatch",
    why: "Paste a rate confirmation and the lane, pay and stops are filled in for you. Your driver gets the dispatch by text.",
    steps: [
      { title: "Open Dispatch and start a new load", body: "Paste the broker's rate confirmation text into the box — origin, destination, pickup/delivery dates, miles and rate are filled in for you.", to: "/app/dispatch" },
      { title: "Check the fields, pick a driver", body: "Fix anything the parser got wrong, then assign a driver (or leave it unassigned and assign later)." },
      { title: "Save — the driver gets a text", body: "The dispatch goes to their phone with every stop. No app to install." },
      { title: "Watch status roll in", body: "Picked up, in transit, delivered — updated from the driver's phone. Share the tracking link with your customer." },
    ],
  },
  drivers: {
    label: "Driver portal", minutes: 2, path: "/app/drivers",
    why: "Add a driver's cell and they get a portal link by text. Status updates and PODs come back from their phone.",
    steps: [
      { title: "Add a driver", body: "Name, cell number, and how they're paid (per mile or percentage) — that's all payroll needs later.", to: "/app/drivers" },
      { title: "They get a text with their portal link", body: "Opens in any phone browser. Nothing to install, no login to remember." },
      { title: "Assign them a load from Dispatch", body: "The load shows up in their portal with the stops and the broker's notes.", to: "/app/dispatch" },
      { title: "They update status and snap the POD", body: "Delivered + POD photo lands in your load record — ready for the invoice." },
    ],
  },
  payroll: {
    label: "Payroll", minutes: 2, path: "/app/payroll",
    why: "Driver pay is built from delivered loads with advances and deductions inline. Paystubs go out in one tap.",
    steps: [
      { title: "Open Payroll and pick the week", body: "Use the arrows or the period picker. Every delivered load in that window is pulled in per driver.", to: "/app/payroll" },
      { title: "Pay is calculated from each driver's rate", body: "Per-mile or percentage, set on the driver. Revenue, fuel and owner net show at the top." },
      { title: "Add adjustments inline", body: "Advances, detention, deductions — type them straight into the row before you send." },
      { title: "Send paystubs or export", body: "One tap texts every driver their stub. Export the spreadsheet for your bookkeeper." },
    ],
  },
  ifta: {
    label: "IFTA state-mileage report", minutes: 1, path: "/app/reports/state-mileage",
    why: "Your delivered loads are split by state for the quarter so IFTA prep starts from a table, not a shoebox.",
    steps: [
      { title: "Open Reports → State mileage", body: "Pick the year and quarter. Delivered loads in that window are pulled automatically.", to: "/app/reports/state-mileage" },
      { title: "Miles are split by state", body: "Each load's miles are attributed to its origin and destination state so you see the quarter at a glance." },
      { title: "Download the CSV", body: "Hand it to whoever files your IFTA, or use it to sanity-check your ELD totals." },
      { title: "Know what it is — and isn't", body: "It's a quick-look estimate for prep. Your actual filing uses exact routed miles per state." },
    ],
  },
  invoices: {
    label: "Invoices", minutes: 2, path: "/app/invoices",
    why: "Turn a delivered load into a PDF invoice with your company details, email it, and track paid vs overdue.",
    steps: [
      { title: "Open Invoices → New invoice", body: "Customer, load reference, amount and due date. Your company details are already on it.", to: "/app/invoices" },
      { title: "Download the PDF", body: "Clean, one page, your logo and MC/DOT on top — the kind brokers pay without a phone call." },
      { title: "Email it to the broker", body: "Add the customer email and send straight from the row." },
      { title: "Track Sent → Paid → Overdue", body: "Statuses update as you mark them; overdue ones float to the top so nothing slips." },
    ],
  },
  vault: {
    label: "Document vault", minutes: 1, path: "/app/vault",
    why: "W-9, COI, authority letter and IFTA license in one place — ready the moment a broker asks for a setup packet.",
    steps: [
      { title: "Open the Vault and upload", body: "Drag in your W-9, certificate of insurance, authority letter, IFTA license — PDFs or photos.", to: "/app/vault" },
      { title: "Tag each file", body: "Insurance, authority, tax, IFTA — the filter chips make them findable in one tap." },
      { title: "Send a setup packet", body: "When a broker asks for paperwork, grab the files from here instead of digging through email." },
      { title: "Keep it current", body: "When your COI renews, upload the new one — the old one stays for your records." },
    ],
  },
};

export const WALKTHROUGH_KEYS = Object.keys(WALKTHROUGHS);
